import React, { useEffect, useState } from "react";
import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import { useParams } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../App";
 import { Circles } from 'react-loader-spinner';
 import { FadeLoader } from 'react-spinners';



const EditCustomer = () => {
  const [tabledata, setTableData] = useState([]);
  const [customerDetails, setCustomerDetails] = useState({
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    zip: "",
    city: "",
    state: "",
    address: "",
    notes: "",
    password: "",
  });
  const [agetdata, setgetdata] = useState([]); //
  const [bookingDetails, setBookingDetails] = useState([]);
  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [selectedValue, setSelectedValue] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); // Pagination state
  const [entriesPerPage, setEntriesPerPage] = useState(10); // Number of entries per page
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("")
  const [error, setError] = useState("");
  const { id } = useParams();
  const CryptoJS = require("crypto-js");
  useEffect(() => {
    let timer;
    if (error) {
      timer = setTimeout(() => {
        setError("");
      }, 5000); // 5 seconds
    }
    return () => clearTimeout(timer);
  }, [error]);
  useEffect(() => {
    const getdata = async () => {
      setLoading(true);
      try {
        // Make the POST request
        const response = await axios.get(
          `${BaseUrl}/backend/api/add_customer.php?action=get_customers&api_key=1`,
         
         
        
        );

        // Log the response data
        console.log("API Response (getdata):", response.data);
        // Check the response
        if (response.data?.customers) {
          console.log("Customers Data:", response.data.customers); // Log the customer data
          setgetdata(response.data.customers);
        } else {
          console.log("No customers or error occurred:", response.data);
          setgetdata([]); // Ensure agetdata is an array even on error
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setgetdata([]); // Ensure agetdata is an array even on error
      }   finally {
      setLoading(false);
    }
    
    };

    getdata();
  }, [currentPage, entriesPerPage]);

  useEffect(() => {
    const comparedata = agetdata.find((v) => v.id == id); // Find matching customer data

    console.log("Compare Data:", comparedata);

    if (comparedata) {
      setCustomerDetails({
        email: comparedata.email,
        firstName: comparedata.first_name,
        lastName: comparedata.last_name,
        phone: comparedata.phone,
        zip: comparedata.zip,
        city: comparedata.city,
        state: comparedata.state,
        address: comparedata.address,
        notes: comparedata.notes,
        password: comparedata.password,
      });
    }
  }, [id, agetdata]); // This effect runs when the id or agetdata changes

  const getUserAppointments = async () => {
    setLoading(true);
    // Define the request payload
    const payload = {
      action: "get_user_appointments_list",
      api_key: "1",
      user_id: id,
      user_type: "client",
    };
  
    try {
      // Make the POST request
      const response = await axios.post(
        `${BaseUrl}/backend/api/user_appointment_list.php`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      // Log the response data
      console.log("API Response (getUserAppointments):", response.data);
  
      // Check if response.data.response exists and is an array
      if (response.data && response.data.response && Array.isArray(response.data.response)) {
        setTableData(response.data.response);
        console.log("Setting table data:", response.data.response);
      } else {
        console.error("Invalid data format:", response.data);
        setTableData([]);
      }
    } catch (err) {
      console.error("Error:", err);
      setTableData([]);
    } finally {
      setLoading(false);
    }
  };

  // Call the API on component mount
  useEffect(() => {
    getUserAppointments();
  }, [id]);

  const editCustomer = async (e) => {
    setLoading(true);
    e.preventDefault(); // Prevent the form from refreshing the page
    const action = {
      action: "edit_customer",
      api_key: "1",
      id: id,
      email: customerDetails.email,
      first_name: customerDetails.firstName,
      last_name: customerDetails.lastName,
      phone: customerDetails.phone,
      address: customerDetails.address,
      zipcode: customerDetails.zip,
      city: customerDetails.city,
      state: customerDetails.state,
      notes: customerDetails.notes,
      status: "E",
      password: customerDetails.password,
    };

    try {
      const response = await axios.post(
        `${BaseUrl}/backend/api/add_customer.php`,
        action,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setSuccessMessage("Customer updated successfully!");
        console.log("Customer updated successfully:", response.data);
      } else {
        console.error("Error updating customer:", response.data);
      }
    } catch (error) {
      console.error("Network error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setSelectedValue(Number(event.target.value)); // Parse value to Number
    setEntriesPerPage(Number(event.target.value)); // Also update entriesPerPage
  };

  const handleSort = (column) => {
    const isAscending = sortColumn === column && sortDirection === "asc";
    setSortColumn(column);
    setSortDirection(isAscending ? "desc" : "asc");

    const sortedData = [...bookingDetails].sort((a, b) => {
      if (column === "date") {
        // Parse date strings into Date objects to compare them
        const dateA = new Date(a[column]);
        const dateB = new Date(b[column]);
        return isAscending ? dateA - dateB : dateB - dateA;
      } else if (typeof a[column] === "string") {
        return isAscending
          ? a[column].localeCompare(b[column])
          : b[column].localeCompare(a[column]);
      } else {
        return isAscending ? a[column] - b[column] : b[column] - a[column];
      }
    });

    setBookingDetails(sortedData);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from the input field
    setCustomerDetails((prevDetails) => ({
      ...prevDetails, // Spread previous state to retain other values
      [name]: value, // Update the specific field based on the name
    }));
  };

  const handleExcelExport = () => {
    const columns = [
      "Service",
      "Booking Date",
      "Status",
      "Payment Method",
      "Details",
      "Staff Booking Status",
    ];

    const rows = (tabledata || []).map((row) => [
      row?.title || "N/A",
      row?.booking_date_time || "N/A",
      row?.booking_status || "N/A",
      row?.total_payment || "N/A",
      `Methods: ${row?.method_name || "N/A"}, Units: ${row?.units || "N/A"}, Addons: ${
        row?.addons || "N/A"
      }`,
      row?.staff_names || "N/A", // Include staff booking status
    ]);

    const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Table Data");
    XLSX.writeFile(wb, "table-data.xlsx");
  };
  const handleCopy = () => {
    // Collect the data from the table
    const tableContent = (tabledata || [])
      .map((row) => {
        return [
          row?.title || "N/A",
          row?.booking_date_time || "N/A",
          row?.booking_status || "N/A",
          row?.total_payment || "N/A",
          `Methods: ${row?.method_name || "N/A"}, Units: ${row?.units || "N/A"}, Addons: ${
            row?.addons || "N/A"
          }`,
          row?.staff_names || "N/A",
        ].join("\t");
      })
      .join("\n"); // Join each row with a newline for better readability

    // Check if Clipboard API is supported
    if (navigator?.clipboard) {
      // Use Clipboard API if available
      navigator.clipboard
        .writeText(tableContent)
        .then(() => {
          alert("Table data copied to clipboard!");
        })
        .catch((error) => {
          console.error("Error copying to clipboard: ", error);
          alert("Failed to copy data. Please try again.");
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = tableContent;
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand("copy");
        alert("Table data copied to clipboard!");
      } catch (err) {
        console.error("Error using execCommand: ", err);
        alert("Failed to copy data. Please try again.");
      }
      document.body.removeChild(textArea); // Remove the textarea after copying
    }
  };

  const handlePdfExport = () => {
    const doc = new jsPDF();

    const columns = [
      "Service",
      "Booking Date",
      "Status",
      "Payment Method",
      "Details",
      "Staff Booking Status",
    ];

    const rows = (tabledata || []).map((row) => [
      row?.title || "N/A",
      row?.booking_date_time || "N/A",
      row?.booking_status || "N/A",
      row?.total_payment || "N/A",
      `Methods: ${row?.method_name || "N/A"}, Units: ${row?.units || "N/A"}, Addons: ${
        row?.addons || "N/A"
      }`,
      row?.staff_names || "N/A", // Include staff booking status
    ]);

    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 20,
      theme: "grid",
      margin: { horizontal: 10 },
      headStyles: {
        fillColor: [0, 123, 255],
        textColor: 255,
      },
    });

    doc.save("table-data.pdf");
  };
  const handleCsvExport = () => {
    const csvData = (tabledata || []).map((row) => [
      row?.title || "N/A",
      row?.booking_date_time || "N/A",
      row?.booking_status || "N/A",
      row?.total_payment || "N/A",
      `Methods: ${row?.method_name || "N/A"}, Units: ${row?.units || "N/A"}, Addons: ${
        row?.addons || "N/A"
      }`,
      row?.staff_names || "N/A", // Include staff booking status
    ]);

    const csvContent = `data:text/csv;charset=utf-8,${csvData
      .map((row) => row.join(","))
      .join("\n")}`;

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "tableData.csv");
    link.click();
  };

  // Pagination logic
  const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNextPage = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  const handlePageChange = (page) => setCurrentPage(page);

  const startIndex = (currentPage - 1) * entriesPerPage;
  const filteredData = bookingDetails; // Assuming no filtering for simplicity
  const paginatedData =
    entriesPerPage === "All"
      ? filteredData
      : filteredData.slice(startIndex, startIndex + entriesPerPage);

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);

  const indexOfLastItem = currentPage * selectedValue;
  const indexOfFirstItem = indexOfLastItem - selectedValue;
  const currentPageData = bookingDetails.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  return (
    <div className="relative min-h-screen">
    {/* Loading Indicator */}
      {loading && (
           <div className="fixed inset-0 flex items-center justify-center z-50">
             <div className="flex flex-col items-center p-3 bg-black border border-white rounded-2xl">
               <FadeLoader 
                 height={15}
                 width={5}
                 color="#ffffff"
                 ariaLabel="loading"
               />
               <h1 className="mt-1 text-lg text-white">Please wait...</h1>
             </div>
           </div>
         )}
         
    <div className="max-w-7xl mx-auto bg-white shadow-lg rounded-md">
      {successMessage && (
        <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{successMessage}</span>
        </div>
      )}

      {error && (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4">
          <span className="block sm:inline">{error}</span>
        </div>
      )}
      <h1 className="text-3xl font-semibold text-blue-600 mb-6">
        Edit Customer Detail
      </h1>

      <form onSubmit={editCustomer} className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
        {/* <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
          {Object.keys(customerDetails).map((key) => (
            <div key={key} className="w-full">
              <label className="block text-sm font-medium text-gray-700 capitalize">
                {key.replace(/_/g, " ")}
              </label>
              <input
                type="text"
                name={key}
                value={customerDetails[key]}
                onChange={handleInputChange}
                className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
              />
            </div>
          ))}
        </div> */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
  {/* Form Fields */}
  {Object.keys(customerDetails).map((key) => (
    <div key={key} className="w-full">
      <label className="block text-sm font-medium text-gray-700 capitalize">
        {key.replace(/_/g, " ")}
      </label>
      <input
        type={key === "password" ? "password" : "text"} // Password field ko hidden rakhne ke liye
        name={key}
        value={customerDetails[key]}
        onChange={handleInputChange}
        disabled={key === "password"} // Sirf password field disable hoga
        className={`mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 focus:outline-none ${
          key === "password" ? "bg-gray-100 cursor-not-allowed" : ""
        }`}
      />
    </div>
  ))}
</div>


        {/* Buttons Section */}
        <div className="flex flex-col sm:flex-row justify-between items-center mt-6 gap-6">
          <button
            type="submit"
            className="w-full sm:w-auto bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-all"
          >
            Save
          </button>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="w-full sm:w-auto bg-gray-300 text-gray-700 py-3 px-6 rounded-md hover:bg-gray-400 transition-all"
          >
            Back
          </button>
        </div>
      </form>

      <div className="p-6 font-sans flex flex-col sm:flex-row sm:flex-wrap justify-between items-center gap-4">
        {/* Search Section */}
        <div className="w-full sm:w-auto flex flex-col items-center">
          <label className="block text-lg font-medium mb-1 sm:mb-0">
            Search:
          </label>
          <input
            type="search"
            placeholder="Enter your search"
            className="p-2 w-full sm:w-64 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
          />
        </div>

        {/* Export Buttons */}
        <div className="w-full sm:w-auto flex flex-wrap justify-center gap-2">
          <button
            onClick={handlePdfExport}
            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
          >
            Export to PDF
          </button>
          <button
            onClick={handleExcelExport}
            className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
          >
            Export to Excel
          </button>
          <button
            onClick={handleCsvExport}
            className="bg-yellow-500 text-white py-2 px-4 rounded-md hover:bg-yellow-600"
          >
            Export to CSV
          </button>
          <button
            onClick={handleCopy}
            className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600"
          >
            Copy Data
          </button>
        </div>

        {/* Show Entries Dropdown */}
        <div className="w-full sm:w-auto flex flex-col items-center">
          <label htmlFor="time-dropdown" className="text-lg font-medium">
            Show
          </label>
          <select
            id="time-dropdown"
            value={selectedValue}
            onChange={handleChange}
            className="w-20 p-2 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
          >
            {[10, 20, 30, 50, "All"].map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>
      </div>
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="overflow-x-auto shadow-md rounded-lg">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th
                  onClick={() => handleSort("service")}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                >
                  Service{" "}
                  {sortColumn === "service" ? (
                    sortDirection === "asc" ? (
                      <ChevronUpIcon className="inline-block w-4 h-4 ml-1" />
                    ) : (
                      <ChevronDownIcon className="inline-block w-4 h-4 ml-1" />
                    )
                  ) : null}
                </th>
                <th
                  onClick={() => handleSort("date")}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                >
                  Date{" "}
                  {sortColumn === "date" ? (
                    sortDirection === "asc" ? (
                      <ChevronUpIcon className="inline-block w-4 h-4 ml-1" />
                    ) : (
                      <ChevronDownIcon className="inline-block w-4 h-4 ml-1" />
                    )
                  ) : null}
                </th>
                <th
                  onClick={() => handleSort("status")}
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                >
                  Status{" "}
                  {sortColumn === "status" ? (
                    sortDirection === "asc" ? (
                      <ChevronUpIcon className="inline-block w-4 h-4 ml-1" />
                    ) : (
                      <ChevronDownIcon className="inline-block w-4 h-4 ml-1" />
                    )
                  ) : null}
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Payment Method
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Details
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Staff Booking Status
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {(tabledata || []).map((row, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                    {row.title}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {row.booking_date_time}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {row.booking_status}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {row.total_payment}
                  </td>
                  <td className="px-6 py-4 whitespace-wrap text-sm text-gray-500">
                    {`Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    {row.staff_names}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {/* Pagination */}
      <div className="flex justify-between items-center p-6">
        <div className="text-sm text-gray-700">
          Showing {startIndex + 1} to {Math.min(startIndex + entriesPerPage, bookingDetails.length)} of{" "}
          {bookingDetails.length} entries
        </div>
        <div className="flex items-center">
          <button
            onClick={handlePrevPage}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded-l"
            disabled={currentPage === 1}
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => handlePageChange(page)}
              className={`bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 ${
                currentPage === page ? "bg-blue-500 text-white" : ""
              }`}
            >
              {page}
            </button>
          ))}
          <button
            onClick={handleNextPage}
            className="bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded-r"
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      </div>
    </div>
   
  </div>
  );
};

export default EditCustomer;


// import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import * as XLSX from "xlsx";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import { BaseUrl } from "../App";
// const EditCustomer = () => {
//   const [tabledata, setTableData] = useState([]);
//   console.log(tabledata);
//   const { id } = useParams();
//   console.log(id);
//   const [customerDetails, setCustomerDetails] = useState({
//     email: "",
//     firstName: "",
//     lastName: "",
//     phone: "",
//     zip: "",
//     city: "",
//     state: "",
//     address: "",
//     notes: "",
//     password: "",
//   });

//   const [bookingDetails, setBookingDetails] = useState([
//     {
//       service: "House Cleaning",
//       date: "08-Dec-2024 01:00 PM",
//       status: "Active",
//       paymentMethod: "Pay At Venue",
//       methods: "Property Based",
//       units: "Bedroom(s)-3",
//       addons: "Fridge Cleaning-5",
//       staffBookingStatus: "Pending",
//     },
//     {
//       service: "Office Cleaning",
//       date: "05-Dec-2024 11:00 AM",
//       status: "Completed",
//       paymentMethod: "Credit Card",
//       methods: "Office Based",
//       units: "Room(s)-2",
//       addons: "Windows Cleaning-3",
//       staffBookingStatus: "Completed",
//     },
//     // Add more mock data as needed
//   ]);

//   const [sortColumn, setSortColumn] = useState(null);
//   const [sortDirection, setSortDirection] = useState(null);
//   const [selectedValue, setSelectedValue] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1); // Pagination state
//   const [entriesPerPage, setEntriesPerPage] = useState(10); // Number of entries per page
//   const [agetdata, setgetdata] = useState([]); //
//   const CryptoJS = require("crypto-js");
//   console.log(agetdata);

//   useEffect(() => {
//     const comparedata = agetdata.find((v) => v.id == id); // Find matching customer data

 
//     if (comparedata) {


//       setCustomerDetails({
//         email: comparedata.email,
//         firstName: comparedata.first_name,
//         lastName: comparedata.last_name,
//         phone: comparedata.phone,
//         zip: comparedata.zip,
//         city: comparedata.city,
//         state: comparedata.state,
//         address: comparedata.address,
//         notes: comparedata.notes,
//         password: comparedata.password
//         ,
//       });
//     }
//   }, [id, agetdata]); // This effect runs when the id or agetdata changes

//   const getdata = async () => {
//     try {
//       // Make the POST request
//       const response = await axios.get(`${BaseUrl}/backend/api/add_customer.php`, {
//         params: {
//           action: "get_customers",
//           api_key: "1", // Replace with actual API key
//           page: currentPage,
//           limit: entriesPerPage === "All" ? 1000 : entriesPerPage,
//         },
//         }
//       );

//       // Log the response data
//       console.log("API Response:",  response.data.customers);
//       // Check the response
//       if (response.data) {
//         console.log("Appointments Data:", response.data.customers ); // Log the appointment data
//         setgetdata(response.data.customers );
//       } else {
//         console.log("No appointments or error occurred:", response.data);
//       }
//     } catch (err) {
//       console.log("Error fetching appointments:", err);
//     }
//   };

//   useEffect(() => {
//     getdata();
//   }, []);

//   const getUserAppointments = async () => {
//     // Define the request payload
//     const payload = {
//       action: "get_user_appointments_list", // Action to fetch user appointments
//       api_key: "1", // API key
//       user_id: id, // User ID (replace with dynamic value if necessary)
//       user_type: "client", // User type
//     };

//     try {
//       // Make the POST request
//       const response = await axios.post(
//         `${BaseUrl}/backend/api/user_appointment_list.php`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Log the response data
//       console.log("API Response:", response.data);

//       // Check the response
//       if (response.data) {
//         console.log("Appointments Data:", response.data.response); // Log the appointment data
//         setTableData(response.data.response);
//       } else {
//         console.log("No appointments or error occurred:", response.data);
//       }
//     } catch (err) {
//       console.log("Error fetching appointments:", err);
//     }
//   };

//   // Call the API on component mount
//   useEffect(() => {
//     getUserAppointments();
//   }, []);

//   const editCustomer = async () => {
//     const action = {
//       action: "edit_customer",
//       api_key: "1",
//       id: id,
//       email: customerDetails.email,
//       first_name: customerDetails.firstName,
//       last_name: customerDetails.lastName,
//       phone: customerDetails.phone,
//       address: customerDetails.address,
//       zipcode: customerDetails.zip,
//       city: customerDetails.city,
//       state: customerDetails.state,
//       notes: customerDetails.notes,
//       status: "E",
//       password: customerDetails.password,
//     };

//     try {
//       const response = await fetch(
//         `${BaseUrl}/backend/api/add_customer.php`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(action),
//         }
//       );
//       const data = await response.json();
//       if (response.ok) {
//         console.log("Customer updated successfully:",response.data);
//       } else {
//         console.error("Error updating customer:", response.data);
//       }
//     } catch (error) {
//       console.error("Network error:", error);
//     }
//   };

//   useEffect(() => {
//     editCustomer();
//   });

//   const handleChange = (event) => {
//     setSelectedValue(event.target.value);
//   };

//   const handleSort = (column) => {
//     const isAscending = sortColumn === column && sortDirection === "asc";
//     setSortColumn(column);
//     setSortDirection(isAscending ? "desc" : "asc");

//     const sortedData = [...bookingDetails].sort((a, b) => {
//       if (column === "date") {
//         // Parse date strings into Date objects to compare them
//         const dateA = new Date(a[column]);
//         const dateB = new Date(b[column]);
//         return isAscending ? dateA - dateB : dateB - dateA;
//       } else if (typeof a[column] === "string") {
//         return isAscending
//           ? a[column].localeCompare(b[column])
//           : b[column].localeCompare(a[column]);
//       } else {
//         return isAscending ? a[column] - b[column] : b[column] - a[column];
//       }
//     });

//     setBookingDetails(sortedData);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target; // Destructure name and value from the input field
//     setCustomerDetails((prevDetails) => ({
//       ...prevDetails, // Spread previous state to retain other values
//       [name]: value, // Update the specific field based on the name
//     }));
//   };

//   const handleExcelExport = () => {
//     const columns = [
//       "Service",
//       "Booking Date",
//       "Status",
//       "Payment Method",
//       "Details",
//       "Staff Booking Status",
//     ];

//     const rows = tabledata.map((row) => [
//       row.title,
//       row.booking_date_time,
//       row.booking_status,
//       row.total_payment,
//       `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//       row.staff_names, // Include staff booking status
//     ]);

//     const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Table Data");
//     XLSX.writeFile(wb, "table-data.xlsx");
//   };
//   const handleCopy = () => {
//     // Collect the data from the table
//     const tableContent = tabledata
//       .map((row) => {
//         return [
//           row.title,
//           row.booking_date_time,
//           row.booking_status,
//           row.total_payment,
//           `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//           row.staff_names,
//         ].join("\t");
//       })
//       .join("\n");  // Join each row with a newline for better readability
  
//     // Check if Clipboard API is supported
//     if (navigator?.clipboard) {
//       // Use Clipboard API if available
//       navigator.clipboard.writeText(tableContent)
//         .then(() => {
//           alert("Table data copied to clipboard!");
//         })
//         .catch((error) => {
//           console.error("Error copying to clipboard: ", error);
//           alert("Failed to copy data. Please try again.");
//         });
//     } else {
//       // Fallback for older browsers
//       const textArea = document.createElement('textarea');
//       textArea.value = tableContent;
//       document.body.appendChild(textArea);
//       textArea.select();
//       try {
//         document.execCommand('copy');
//         alert("Table data copied to clipboard!");
//       } catch (err) {
//         console.error("Error using execCommand: ", err);
//         alert("Failed to copy data. Please try again.");
//       }
//       document.body.removeChild(textArea);  // Remove the textarea after copying
//     }
//   };
  
  
//   const handlePdfExport = () => {
//     const doc = new jsPDF();

//     const columns = [
//       "Service",
//       "Booking Date",
//       "Status",
//       "Payment Method",
//       "Details",
//       "Staff Booking Status",
//     ];

//     const rows = tabledata.map((row) => [
//       row.title,
//       row.booking_date_time,
//       row.booking_status,
//       row.total_payment,
//       `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//       row.staff_names, // Include staff booking status
//     ]);

//     doc.autoTable({
//       head: [columns],
//       body: rows,
//       startY: 20,
//       theme: "grid",
//       margin: { horizontal: 10 },
//       headStyles: {
//         fillColor: [0, 123, 255],
//         textColor: 255,
//       },
//     });

//     doc.save("table-data.pdf");
//   };
//   const handleCsvExport = () => {
//     const csvData = tabledata.map((row) => [
//       row.title,
//       row.booking_date_time,
//       row.booking_status,
//       row.total_payment,
//       `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//       row.staff_names, // Include staff booking status
//     ]);

//     const csvContent = `data:text/csv;charset=utf-8,${csvData
//       .map((row) => row.join(","))
//       .join("\n")}`;

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "tableData.csv");
//     link.click();
//   };

//   // const editCustomer = async () => {
//   //   const action = {
//   //     action: "update_user",
//   //     api_key: "1",
//   //     id: id,
//   //     email: customerDetails.email,
//   //     first_name: customerDetails.firstName,
//   //     last_name: customerDetails.lastName,
//   //     phone: customerDetails.phone,
//   //     address: customerDetails.address,
//   //     zipcode: customerDetails.zip,
//   //     city: customerDetails.city,
//   //     state: customerDetails.state,
//   //     notes: customerDetails.notes,
//   //     status: "E",
//   //     password: customerDetails.password
//   //   };

//   //   try {
//   //     const response = await fetch("http://yourdomain.com/api_endpoint.php", {
//   //       method: "POST",
//   //       headers: {
//   //         "Content-Type": "application/json"
//   //       },
//   //       body: JSON.stringify(action)
//   //     });

//   //     const data = await response.json();

//   //     if (response.ok) {
//   //       console.log("Customer updated successfully:", data);
//   //     } else {
//   //       console.error("Error updating customer:", data);
//   //     }
//   //   } catch (error) {
//   //     console.error("Network error:", error);
//   //   }
//   // };

//   // useEffect(() => {
//   //   editCustomer()
//   // },[])

//   // Pagination logic
//   const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNextPage = () =>
//     setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   const handlePageChange = (page) => setCurrentPage(page);

//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const filteredData = bookingDetails; // Assuming no filtering for simplicity
//   const paginatedData =
//     entriesPerPage === "All"
//       ? filteredData
//       : filteredData.slice(startIndex, startIndex + entriesPerPage);

//   const totalPages = Math.ceil(filteredData.length / entriesPerPage);

//   const indexOfLastItem = currentPage * selectedValue;
//   const indexOfFirstItem = indexOfLastItem - selectedValue;
//   const currentPageData = bookingDetails.slice(
//     indexOfFirstItem,
//     indexOfLastItem
//   );

//   return (
//     <div className="max-w-7xl mx-auto  bg-white shadow-lg rounded-md">
//     <h1 className="text-3xl font-semibold text-blue-600 mb-6">
//       Edit Customer Detail
//     </h1>

//     <form onSubmit={editCustomer} className="max-w-4xl mx-auto bg-white p-6 rounded-lg shadow-md">
//   <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
//     {/* Form Fields */}
//     {Object.keys(customerDetails).map((key) => (
//       <div key={key} className="w-full">
//         <label className="block text-sm font-medium text-gray-700 capitalize">
//           {key.replace(/_/g, " ")}
//         </label>
//         <input
//           type="text"
//           name={key}
//           value={customerDetails[key]}
//           onChange={handleInputChange}
//           className="mt-1 block w-full p-3 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
//         />
//       </div>
//     ))}
//   </div>

//   {/* Buttons Section */}
//   <div className="flex flex-col sm:flex-row justify-between items-center mt-6 gap-6">
//     <button
//       type="submit"
//       className="w-full sm:w-auto bg-blue-600 text-white py-3 px-6 rounded-md hover:bg-blue-700 transition-all"
//     >
//       Save
//     </button>
//     <button
//       type="button"
//       onClick={() => window.history.back()}
//       className="w-full sm:w-auto bg-gray-300 text-gray-700 py-3 px-6 rounded-md hover:bg-gray-400 transition-all"
//     >
//       Back
//     </button>
//   </div>
// </form>


// <div className="p-6 font-sans flex flex-col sm:flex-row sm:flex-wrap justify-between items-center gap-4">

// {/* Search Section */}
// <div className="w-full sm:w-auto flex flex-col items-center">
//   <label className="block text-lg font-medium mb-1 sm:mb-0">
//     Search:
//   </label>
//   <input
//     type="search"
//     placeholder="Enter your search"
//     className="p-2 w-full sm:w-64 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
//   />
// </div>

// {/* Export Buttons */}
// <div className="w-full sm:w-auto flex flex-wrap justify-center gap-2">
//   <button
//     onClick={handlePdfExport}
//     className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
//   >
//     Export to PDF
//   </button>
//   <button
//     onClick={handleExcelExport}
//     className="bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600"
//   >
//     Export to Excel
//   </button>
//   <button
//     onClick={handleCsvExport}
//     className="bg-yellow-500 text-white py-2 px-4 rounded-md hover:bg-yellow-600"
//   >
//     Export to CSV
//   </button>
//   <button
//     onClick={handleCopy}
//     className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600"
//   >
//     Copy Data
//   </button>
// </div>

// {/* Show Entries Dropdown */}
// <div className="w-full sm:w-auto flex flex-col items-center">
//   <label htmlFor="time-dropdown" className="text-lg font-medium">
//     Show
//   </label>
//   <select
//     id="time-dropdown"
//     value={selectedValue}
//     onChange={handleChange}
//     className="p-2 w-24 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
//   >
//     <option value={10}>10</option>
//     <option value={25}>25</option>
//     <option value={50}>50</option>
//     <option value={100}>100</option>
//   </select>
// </div>

// </div>


// <div className="w-full overflow-x-auto">
// {/* Mobile Card View */}
// <div className="sm:hidden">
//   {tabledata?.map((booking, index) => (
//     <div key={index} className="border border-gray-300 p-4 mb-4 shadow-sm rounded-lg bg-white">
//       <div className="text-lg font-semibold">{booking.title}</div>
//       <div className="text-sm text-gray-600">Date: {booking.booking_date_time}</div>
//       <div className="text-sm text-gray-600">Status: {booking.booking_status}</div>
//       <div className="text-sm text-gray-600">Payment: {booking.total_payment}</div>
//       <div className="text-sm text-gray-600 mt-2">
//         <b>Methods:</b> {booking.method_name} <br />
//         <b>Units:</b> {booking.units} <br />
//         <b>Addons:</b> {booking.addons}
//       </div>
//       <div className="text-sm text-gray-600 mt-2">
//         <b>{booking.staff_names}</b> - Accept
//       </div>
//     </div>
//   ))}
// </div>

// {/* Tablet and Desktop Table View */}
// <div className="hidden sm:block">
//   <table className="min-w-full table-auto border-collapse border border-gray-300">
//     <thead>
//       <tr className="bg-gray-100 text-left">
//         {["Service", "Date", "Status", "Payment", "More Details", "Staff Booking Status"].map((column, index) => (
//           <th
//             key={index}
//             className="px-4 py-2 text-sm font-medium text-gray-900 cursor-pointer border-b border-gray-200 whitespace-nowrap"
//             onClick={() => handleSort(column.toLowerCase())}
//           >
//             {column}
//             {sortColumn === column.toLowerCase() &&
//               (sortDirection === "asc" ? <ChevronUpIcon size={16} /> : <ChevronDownIcon size={16} />)}
//           </th>
//         ))}
//       </tr>
//     </thead>
//     <tbody>
//       {tabledata?.map((booking, index) => (
//         <tr key={index} className="border-t border-gray-200 hover:bg-gray-50">
//           <td className="px-4 py-2 text-sm text-gray-900 border-b">{booking.title}</td>
//           <td className="px-4 py-2 text-sm text-gray-900 border-b">{booking.booking_date_time}</td>
//           <td className="px-4 py-2 text-sm text-gray-900 border-b">{booking.booking_status}</td>
//           <td className="px-4 py-2 text-sm text-gray-900 border-b">{booking.total_payment}</td>
//           <td className="px-4 py-2 text-sm text-gray-900 border-b">
//             <b>Methods:</b> {booking.method_name} <br />
//             <b>Units:</b> {booking.units} <br />
//             <b>Addons:</b> {booking.addons}
//           </td>
//           <td className="px-4 py-2 text-sm text-gray-900 border-b">
//             <b>{booking.staff_names}</b> - Accept
//           </td>
//         </tr>
//       ))}
//     </tbody>
//   </table>
// </div>
// </div>


// {/* Showing Entries */}
// <span className="text-sm mt-2 block text-gray-600 text-center">
// Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, bookingDetails.length)} of {bookingDetails.length} entries
// </span>

// {/* Pagination */}
// {entriesPerPage !== "All" && (
// <div className="flex flex-wrap items-center justify-center mt-4 gap-2">
//   <button
//     onClick={handlePrevPage}
//     disabled={currentPage === 1}
//     className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400 disabled:opacity-50"
//   >
//     Previous
//   </button>

//   {[...Array(totalPages).keys()].map((page) => (
//     <button
//       key={page + 1}
//       onClick={() => handlePageChange(page + 1)}
//       className={`px-4 py-2 border rounded-md ${
//         currentPage === page + 1
//           ? "bg-blue-500 text-white"
//           : "bg-gray-200 hover:bg-gray-300"
//       }`}
//     >
//       {page + 1}
//     </button>
//   ))}

//   <button
//     onClick={handleNextPage}
//     disabled={currentPage === totalPages}
//     className="px-4 py-2 bg-gray-300 rounded-md hover:bg-gray-400 disabled:opacity-50"
//   >
//     Next
//   </button>
// </div>
// )}

//     {/* Pagination Controls */}
//     {/* <div className="flex justify-between mt-4">
//       <button
//         onClick={handlePrevPage}
//         className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//         disabled={currentPage === 1}
//       >
//         Previous
//       </button>
//       <button
//         onClick={handleNextPage}
//         className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//         disabled={currentPage === totalPages}
//       >
//         Next
//       </button>
//     </div> */}
//   </div>
//   );
// };

// export default EditCustomer;



// import React, { useEffect, useState } from "react";
// import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import * as XLSX from "xlsx";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// const EditCustomer = () => {
//   const [tabledata, setTableData] = useState([]);
//   console.log(tabledata);
//   const { id } = useParams();
//   console.log(id);
//   const [customerDetails, setCustomerDetails] = useState({
//     email: "",
//     firstName: "",
//     lastName: "",
//     phone: "",
//     zip: "",
//     city: "",
//     state: "",
//     address: "",
//     notes: "",
//     password: "",
//   });

//   const [bookingDetails, setBookingDetails] = useState([
//     {
//       service: "House Cleaning",
//       date: "08-Dec-2024 01:00 PM",
//       status: "Active",
//       paymentMethod: "Pay At Venue",
//       methods: "Property Based",
//       units: "Bedroom(s)-3",
//       addons: "Fridge Cleaning-5",
//       staffBookingStatus: "Pending",
//     },
//     {
//       service: "Office Cleaning",
//       date: "05-Dec-2024 11:00 AM",
//       status: "Completed",
//       paymentMethod: "Credit Card",
//       methods: "Office Based",
//       units: "Room(s)-2",
//       addons: "Windows Cleaning-3",
//       staffBookingStatus: "Completed",
//     },
//     // Add more mock data as needed
//   ]);

//   const [sortColumn, setSortColumn] = useState(null);
//   const [sortDirection, setSortDirection] = useState(null);
//   const [selectedValue, setSelectedValue] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1); // Pagination state
//   const [entriesPerPage, setEntriesPerPage] = useState(10); // Number of entries per page
//   const [agetdata, setgetdata] = useState([]); //
//   const CryptoJS = require("crypto-js");
//   console.log(agetdata);

//   useEffect(() => {
//     const comparedata = agetdata.find((v) => v.id == id); // Find matching customer data

 
//     if (comparedata) {


//       setCustomerDetails({
//         email: comparedata.email,
//         firstName: comparedata.first_name,
//         lastName: comparedata.last_name,
//         phone: comparedata.phone,
//         zip: comparedata.zip,
//         city: comparedata.city,
//         state: comparedata.state,
//         address: comparedata.address,
//         notes: comparedata.notes,
//         password: comparedata.password
//         ,
//       });
//     }
//   }, [id, agetdata]); // This effect runs when the id or agetdata changes

//   const getdata = async () => {
//     try {
//       // Make the POST request
//       const response = await axios.get('http://10.27.1.112:80/megaclean/backend/api/add_customer.php', {
//         params: {
//           action: "get_customers",
//           api_key: "1", // Replace with actual API key
//           page: currentPage,
//           limit: entriesPerPage === "All" ? 1000 : entriesPerPage,
//         },
//         }
//       );

//       // Log the response data
//       console.log("API Response:",  response.data.customers);
//       // Check the response
//       if (response.data) {
//         console.log("Appointments Data:", response.data.customers ); // Log the appointment data
//         setgetdata(response.data.customers );
//       } else {
//         console.log("No appointments or error occurred:", response.data);
//       }
//     } catch (err) {
//       console.log("Error fetching appointments:", err);
//     }
//   };

//   useEffect(() => {
//     getdata();
//   }, []);

//   const getUserAppointments = async () => {
//     // Define the request payload
//     const payload = {
//       action: "get_user_appointments_list", // Action to fetch user appointments
//       api_key: "1", // API key
//       user_id: id, // User ID (replace with dynamic value if necessary)
//       user_type: "client", // User type
//     };

//     try {
//       // Make the POST request
//       const response = await axios.post(
//         "http://10.27.1.112:80/megaclean/backend/api/user_appointment_list.php",
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       // Log the response data
//       console.log("API Response:", response.data);

//       // Check the response
//       if (response.data) {
//         console.log("Appointments Data:", response.data.response); // Log the appointment data
//         setTableData(response.data.response);
//       } else {
//         console.log("No appointments or error occurred:", response.data);
//       }
//     } catch (err) {
//       console.log("Error fetching appointments:", err);
//     }
//   };

//   // Call the API on component mount
//   useEffect(() => {
//     getUserAppointments();
//   }, []);

//   const editCustomer = async () => {
//     const action = {
//       action: "edit_customer",
//       api_key: "1",
//       id: id,
//       email: customerDetails.email,
//       first_name: customerDetails.firstName,
//       last_name: customerDetails.lastName,
//       phone: customerDetails.phone,
//       address: customerDetails.address,
//       zipcode: customerDetails.zip,
//       city: customerDetails.city,
//       state: customerDetails.state,
//       notes: customerDetails.notes,
//       status: "E",
//       password: customerDetails.password,
//     };

//     try {
//       const response = await fetch(
//         "http://localhost/megaclean/backend/api/add_customer.php",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(action),
//         }
//       );
//       const data = await response.json();
//       if (response.ok) {
//         console.log("Customer updated successfully:",response.data);
//       } else {
//         console.error("Error updating customer:", response.data);
//       }
//     } catch (error) {
//       console.error("Network error:", error);
//     }
//   };

//   useEffect(() => {
//     editCustomer();
//   });

//   const handleChange = (event) => {
//     setSelectedValue(event.target.value);
//   };

//   const handleSort = (column) => {
//     const isAscending = sortColumn === column && sortDirection === "asc";
//     setSortColumn(column);
//     setSortDirection(isAscending ? "desc" : "asc");

//     const sortedData = [...bookingDetails].sort((a, b) => {
//       if (column === "date") {
//         // Parse date strings into Date objects to compare them
//         const dateA = new Date(a[column]);
//         const dateB = new Date(b[column]);
//         return isAscending ? dateA - dateB : dateB - dateA;
//       } else if (typeof a[column] === "string") {
//         return isAscending
//           ? a[column].localeCompare(b[column])
//           : b[column].localeCompare(a[column]);
//       } else {
//         return isAscending ? a[column] - b[column] : b[column] - a[column];
//       }
//     });

//     setBookingDetails(sortedData);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target; // Destructure name and value from the input field
//     setCustomerDetails((prevDetails) => ({
//       ...prevDetails, // Spread previous state to retain other values
//       [name]: value, // Update the specific field based on the name
//     }));
//   };

//   const handleExcelExport = () => {
//     const columns = [
//       "Service",
//       "Booking Date",
//       "Status",
//       "Payment Method",
//       "Details",
//       "Staff Booking Status",
//     ];

//     const rows = tabledata.map((row) => [
//       row.title,
//       row.booking_date_time,
//       row.booking_status,
//       row.total_payment,
//       `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//       row.staff_names, // Include staff booking status
//     ]);

//     const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Table Data");
//     XLSX.writeFile(wb, "table-data.xlsx");
//   };
//   const handleCopy = () => {
//     const tableContent = tabledata
//       .map((row) => {
//         return [
//           row.title,
//           row.booking_date_time,
//           row.booking_status,
//           row.total_payment,
//           `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//           row.staff_names, // Staff booking status
//         ].join("\t");
//       })
//       .join("\n");

//     navigator.clipboard.writeText(tableContent).then(() => {
//       alert("Table data copied to clipboard!");
//     });
//   };
//   const handlePdfExport = () => {
//     const doc = new jsPDF();

//     const columns = [
//       "Service",
//       "Booking Date",
//       "Status",
//       "Payment Method",
//       "Details",
//       "Staff Booking Status",
//     ];

//     const rows = tabledata.map((row) => [
//       row.title,
//       row.booking_date_time,
//       row.booking_status,
//       row.total_payment,
//       `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//       row.staff_names, // Include staff booking status
//     ]);

//     doc.autoTable({
//       head: [columns],
//       body: rows,
//       startY: 20,
//       theme: "grid",
//       margin: { horizontal: 10 },
//       headStyles: {
//         fillColor: [0, 123, 255],
//         textColor: 255,
//       },
//     });

//     doc.save("table-data.pdf");
//   };
//   const handleCsvExport = () => {
//     const csvData = tabledata.map((row) => [
//       row.title,
//       row.booking_date_time,
//       row.booking_status,
//       row.total_payment,
//       `Methods: ${row.method_name}, Units: ${row.units}, Addons: ${row.addons}`,
//       row.staff_names, // Include staff booking status
//     ]);

//     const csvContent = `data:text/csv;charset=utf-8,${csvData
//       .map((row) => row.join(","))
//       .join("\n")}`;

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "tableData.csv");
//     link.click();
//   };

//   // const editCustomer = async () => {
//   //   const action = {
//   //     action: "update_user",
//   //     api_key: "1",
//   //     id: id,
//   //     email: customerDetails.email,
//   //     first_name: customerDetails.firstName,
//   //     last_name: customerDetails.lastName,
//   //     phone: customerDetails.phone,
//   //     address: customerDetails.address,
//   //     zipcode: customerDetails.zip,
//   //     city: customerDetails.city,
//   //     state: customerDetails.state,
//   //     notes: customerDetails.notes,
//   //     status: "E",
//   //     password: customerDetails.password
//   //   };

//   //   try {
//   //     const response = await fetch("http://yourdomain.com/api_endpoint.php", {
//   //       method: "POST",
//   //       headers: {
//   //         "Content-Type": "application/json"
//   //       },
//   //       body: JSON.stringify(action)
//   //     });

//   //     const data = await response.json();

//   //     if (response.ok) {
//   //       console.log("Customer updated successfully:", data);
//   //     } else {
//   //       console.error("Error updating customer:", data);
//   //     }
//   //   } catch (error) {
//   //     console.error("Network error:", error);
//   //   }
//   // };

//   // useEffect(() => {
//   //   editCustomer()
//   // },[])

//   // Pagination logic
//   const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNextPage = () =>
//     setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   const handlePageChange = (page) => setCurrentPage(page);

//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const filteredData = bookingDetails; // Assuming no filtering for simplicity
//   const paginatedData =
//     entriesPerPage === "All"
//       ? filteredData
//       : filteredData.slice(startIndex, startIndex + entriesPerPage);

//   const totalPages = Math.ceil(filteredData.length / entriesPerPage);

//   const indexOfLastItem = currentPage * selectedValue;
//   const indexOfFirstItem = indexOfLastItem - selectedValue;
//   const currentPageData = bookingDetails.slice(
//     indexOfFirstItem,
//     indexOfLastItem
//   );

//   return (
//     <div className="max-w-7xl mx-auto p-6 bg-white shadow-lg rounded-md">
//       <h1 className="text-3xl font-semibold text-blue-600 mb-6">
//         Edit Customer Detail
//       </h1>

//       <form onSubmit={editCustomer}>
//         <div className="grid grid-cols-2 gap-6 mb-6">
//           {/* Form Fields */}
//           {Object.keys(customerDetails).map((key) => (
//             <div key={key}>
//               <label className="block text-sm font-medium text-gray-700">
//                 {key}
//               </label>
//               <input
//                 type="text"
//                 name={key} // Name should match the key in state
//                 value={customerDetails[key]} // Bind to state value
//                 onChange={handleInputChange} // Handle change
//                 className="mt-1 block w-full h-10 border-gray-300 border-2 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
//               />
//             </div>
//           ))}
//         </div>

//         <div className="flex justify-end mb-6">
//           <button
//             type="submit"
//             className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none"
//           >
//             Save
//           </button>
//           <button
//             type="button"
//             onClick={() => window.history.back()}
//             className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//           >
//             Back
//           </button>
//         </div>
//       </form>

//       <div className="p-6 font-sans flex flex-wrap justify-between sm:justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
//         {/* Search Section - Left Side on larger screens, Centered on small screens */}
//         <div className="flex items-center sm:w-auto w-full sm:justify-center">
//           <label className="block text-lg font-medium mb-2 sm:mb-0">
//             Search:
//             <input
//               type="search"
//               placeholder="Enter your search"
//               className="mt-2 p-2 w-48 sm:w-64 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
//             />
//           </label>
//         </div>

//         {/* Export Options - Right Side on larger screens, Centered on small screens */}
//         <div className="flex flex-wrap justify-end sm:justify-center sm:space-x-4 space-x-0 sm:flex-row sm:items-center w-full sm:w-auto">
//           <button
//             onClick={handlePdfExport}
//             className="mx-2 bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//           >
//             Export to PDF
//           </button>
//           <button
//             onClick={handleExcelExport}
//             className="mx-2 bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//           >
//             Export to Excel
//           </button>
//           <button
//             onClick={handleCsvExport}
//             className="mx-2 bg-yellow-500 text-white py-2 px-4 rounded-md hover:bg-yellow-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//           >
//             Export to CSV
//           </button>
//           <button
//             onClick={handleCopy}
//             className="mx-2 bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//           >
//             Copy Data
//           </button>
//         </div>

//         {/* Show Entries Dropdown - Left Side on larger screens, Centered on small screens */}
//         <div className="flex items-center sm:w-auto w-full sm:ml-4 sm:justify-center">
//           <label htmlFor="time-dropdown" className="text-lg font-medium mr-2">
//             Show
//             <select
//               id="time-dropdown"
//               value={selectedValue}
//               onChange={handleChange}
//               className="ml-2 p-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500"
//             >
//               <option value={10}>10</option>
//               <option value={25}>25</option>
//               <option value={50}>50</option>
//               <option value={100}>100</option>
//             </select>
//             entries
//           </label>
//         </div>
//       </div>

//       <div className="overflow-x-auto">
//         <table className="min-w-full table-auto border-collapse border border-gray-300">
//           <thead>
//             <tr className="bg-gray-100">
//               {/* Table Headers with Sorting */}
//               {["service", "date", "status", "paymentMethod"].map((column) => (
//                 <th
//                   key={column}
//                   className="px-6 py-3 text-sm font-medium text-gray-900 cursor-pointer border-b border-gray-200"
//                   onClick={() => handleSort(column)}
//                 >
//                   {column.charAt(0).toUpperCase() + column.slice(1)}
//                   {sortColumn === column &&
//                     (sortDirection === "asc" ? (
//                       <ChevronUpIcon size={16} />
//                     ) : (
//                       <ChevronDownIcon size={16} />
//                     ))}
//                 </th>
//               ))}
//               <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">
//                 More Details
//               </th>
//               <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">
//                 Staff Booking Status
//               </th>
//             </tr>
//           </thead>
//           <tbody>
//             {tabledata?.map((booking, index) => (
//               <tr key={index} className="border-t border-gray-200">
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   {booking.title}
//                 </td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   {booking.booking_date_time}
//                 </td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   {booking.booking_status}
//                 </td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   {booking.total_payment}
//                 </td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   <b>Methods - </b>
//                   {booking.method_name} <br /> <b>Units -</b> {booking.units}{" "}
//                   <br /> <b>Addons -</b> {booking.addons}
//                 </td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   <b>{booking.staff_names}</b>- Accept
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <span className="text-sm  mt-2  text-gray-600">
//         Showing {indexOfFirstItem + 1} to{" "}
//         {Math.min(indexOfLastItem, bookingDetails.length)} of{" "}
//         {bookingDetails.length} entries
//       </span>

//       {entriesPerPage !== "All" && (
//         <div className="flex items-center  justify-end mt-3">
//           <button
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           {[...Array(totalPages).keys()].map((page) => (
//             <button
//               key={page + 1}
//               onClick={() => handlePageChange(page + 1)}
//               className={`px-4 py-2 border ${
//                 currentPage === page + 1
//                   ? "bg-blue-500 text-white"
//                   : "bg-gray-200 hover:bg-gray-300"
//               }`}
//             >
//               {page + 1}
//             </button>
//           ))}
//           <button
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Pagination Controls */}
//       {/* <div className="flex justify-between mt-4">
//         <button
//           onClick={handlePrevPage}
//           className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//           disabled={currentPage === 1}
//         >
//           Previous
//         </button>
//         <button
//           onClick={handleNextPage}
//           className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//           disabled={currentPage === totalPages}
//         >
//           Next
//         </button>
//       </div> */}
//     </div>
//   );
// };

// export default EditCustomer;



// import React, { useState } from "react";
// import { ChevronUpIcon, ChevronDownIcon } from "lucide-react";
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';
// import * as XLSX from 'xlsx';

// const EditCustomer = () => {
//   const [customerDetails, setCustomerDetails] = useState({
//     email: "johndoe@example.com",
//     firstName: "John",
//     lastName: "Doe",
//     phone: "+10000000000",
//     zip: "90001",
//     city: "Perrine",
//     state: "USA",
//     address: "Perrine, USA",
//     notes: "Happy Booking",
//     password: "********",
//   });

//   const [bookingDetails, setBookingDetails] = useState([
//     {
//       service: "House Cleaning",
//       date: "08-Dec-2024 01:00 PM",
//       status: "Active",
//       paymentMethod: "Pay At Venue",
//       methods: "Property Based",
//       units: "Bedroom(s)-3",
//       addons: "Fridge Cleaning-5",
//       staffBookingStatus: "Pending",
//     },
//     {
//       service: "Office Cleaning",
//       date: "05-Dec-2024 11:00 AM",
//       status: "Completed",
//       paymentMethod: "Credit Card",
//       methods: "Office Based",
//       units: "Room(s)-2",
//       addons: "Windows Cleaning-3",
//       staffBookingStatus: "Completed",
//     },
//     // Add more mock data as needed
//   ]);

//   const [sortColumn, setSortColumn] = useState(null);
//   const [sortDirection, setSortDirection] = useState(null);
//   const [selectedValue, setSelectedValue] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1); // Pagination state
//   const [entriesPerPage, setEntriesPerPage] = useState(10); // Number of entries per page

//   const handleChange = (event) => {
//     setSelectedValue(event.target.value);
//   };

//   const handleSort = (column) => {
//     const isAscending = sortColumn === column && sortDirection === "asc";
//     setSortColumn(column);
//     setSortDirection(isAscending ? "desc" : "asc");

//     const sortedData = [...bookingDetails].sort((a, b) => {
//       if (column === "date") {
//         // Parse date strings into Date objects to compare them
//         const dateA = new Date(a[column]);
//         const dateB = new Date(b[column]);
//         return isAscending ? dateA - dateB : dateB - dateA;
//       } else if (typeof a[column] === "string") {
//         return isAscending
//           ? a[column].localeCompare(b[column])
//           : b[column].localeCompare(a[column]);
//       } else {
//         return isAscending ? a[column] - b[column] : b[column] - a[column];
//       }
//     });

//     setBookingDetails(sortedData);
//   };

//   const handleInputChange = (e) => {
//     setCustomerDetails({
//       ...customerDetails,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const saveDetails = () => {
//     console.log("Details saved");
//   };

//   const handleExcelExport = () => {
//     const columns = [
//       "Service",
//       "Booking Date",
//       "Status",
//       "Payment Method",
//       "Details",
//     ];

//     const rows = bookingDetails.map((row) => [
//       row.service,
//       row.date,
//       row.status,
//       row.paymentMethod,
//       `Methods: ${row.methods}, Units: ${row.units}, Addons: ${row.addons}`,
//     ]);

//     const ws = XLSX.utils.aoa_to_sheet([columns, ...rows]);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Table Data");
//     XLSX.writeFile(wb, "table-data.xlsx");
//   };

//   const handleCopy = () => {
//     const tableContent = bookingDetails
//       .map((row) => {
//         return Object.values(row).join("\t");
//       })
//       .join("\n");

//     navigator.clipboard.writeText(tableContent).then(() => {
//       alert("Table data copied to clipboard!");
//     });
//   };

//   const handlePdfExport = () => {
//     const doc = new jsPDF();

//     const columns = [
//       "Service",
//       "Booking Date",
//       "Status",
//       "Payment Method",
//       "Details",
//     ];

//     const rows = bookingDetails.map((row) => [
//       row.service,
//       row.date,
//       row.status,
//       row.paymentMethod,
//       `Methods: ${row.methods}, Units: ${row.units}, Addons: ${row.addons}`,
//     ]);

//     doc.autoTable({
//       head: [columns],
//       body: rows,
//       startY: 20,
//       theme: "grid",
//       margin: { horizontal: 10 },
//       headStyles: {
//         fillColor: [0, 123, 255],
//         textColor: 255,
//       },
//     });

//     doc.save("table-data.pdf");
//   };

//   const handleCsvExport = () => {
//     const csvData = bookingDetails.map((row) =>
//       Object.values(row).join(",")
//     );

//     const csvContent = `data:text/csv;charset=utf-8,${csvData.join("\n")}`;

//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement("a");
//     link.setAttribute("href", encodedUri);
//     link.setAttribute("download", "tableData.csv");
//     link.click();
//   };

//   // Pagination logic
//   const handlePrevPage = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
//   const handleNextPage = () => setCurrentPage((prev) => Math.min(prev + 1, totalPages));
//   const handlePageChange = (page) => setCurrentPage(page);

//   const startIndex = (currentPage - 1) * entriesPerPage;
//   const filteredData = bookingDetails; // Assuming no filtering for simplicity
//   const paginatedData = entriesPerPage === "All"
//     ? filteredData
//     : filteredData.slice(startIndex, startIndex + entriesPerPage);

//   const totalPages = Math.ceil(filteredData.length / entriesPerPage);

//   const indexOfLastItem = currentPage * selectedValue;
//   const indexOfFirstItem = indexOfLastItem - selectedValue;
//   const currentPageData = bookingDetails.slice(indexOfFirstItem, indexOfLastItem);

//   return (
//     <div className="max-w-7xl mx-auto p-6 bg-white shadow-lg rounded-md">
//       <h1 className="text-3xl font-semibold text-blue-600 mb-6">Edit Customer Detail</h1>

//       <div className="grid grid-cols-2 gap-6 mb-6">
//         {/* Form Fields */}
//         {Object.keys(customerDetails).map((key) => (
//           <div key={key}>
//             <label className="block text-sm font-medium text-gray-700">{key}</label>
//             <input
//               type="text"
//               name={key}
//               value={customerDetails[key]}
//               onChange={handleInputChange}
//               className="mt-1 block w-full h-10 border-gray-300 border-2 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
//             />
//           </div>
//         ))}
//       </div>

//       <div className="flex justify-end  mb-6">
//         <button
//           onClick={saveDetails}
//           className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none"
//         >
//           Save
//         </button>
//         <button className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none">
//           Back
//         </button>
//       </div>

//       <div className="p-6 font-sans flex flex-wrap justify-between sm:justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">

// {/* Search Section - Left Side on larger screens, Centered on small screens */}
// <div className="flex items-center sm:w-auto w-full sm:justify-center">
//   <label className="block text-lg font-medium mb-2 sm:mb-0">
//     Search:
//     <input
//       type="search"
//       placeholder="Enter your search"
//       className="mt-2 p-2 w-48 sm:w-64 border rounded-md focus:ring-2 focus:ring-blue-500 text-sm"
//     />
//   </label>
// </div>

// {/* Export Options - Right Side on larger screens, Centered on small screens */}
// <div className="flex flex-wrap justify-end sm:justify-center sm:space-x-4 space-x-0 sm:flex-row sm:items-center w-full sm:w-auto">
//   <button
//     onClick={handlePdfExport}
//     className="mx-2 bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//   >
//     Export to PDF
//   </button>
//   <button
//     onClick={handleExcelExport}
//     className="mx-2 bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//   >
//     Export to Excel
//   </button>
//   <button
//     onClick={handleCsvExport}
//     className="mx-2 bg-yellow-500 text-white py-2 px-4 rounded-md hover:bg-yellow-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//   >
//     Export to CSV
//   </button>
//   <button
//     onClick={handleCopy}
//     className="mx-2 bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 mb-2 sm:mb-0 md:mt-3 md:mb-3"
//   >
//     Copy Data
//   </button>
// </div>

// {/* Show Entries Dropdown - Left Side on larger screens, Centered on small screens */}
// <div className="flex items-center sm:w-auto w-full sm:ml-4 sm:justify-center">
//   <label htmlFor="time-dropdown" className="text-lg font-medium mr-2">
//     Show
//     <select
//       id="time-dropdown"
//       value={selectedValue}
//       onChange={handleChange}
//       className="ml-2 p-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500"
//     >
//       <option value={10}>10</option>
//       <option value={25}>25</option>
//       <option value={50}>50</option>
//       <option value={100}>100</option>
//     </select>
//     entries
//   </label>
// </div>

// </div>

//       <div className="overflow-x-auto">
//         <table className="min-w-full table-auto border-collapse border border-gray-300">
//           <thead>
//             <tr className="bg-gray-100">
//               {/* Table Headers with Sorting */}
//               {["service", "date", "status", "paymentMethod"].map((column) => (
//                 <th
//                   key={column}
//                   className="px-6 py-3 text-sm font-medium text-gray-900 cursor-pointer border-b border-gray-200"
//                   onClick={() => handleSort(column)}
//                 >
//                   {column.charAt(0).toUpperCase() + column.slice(1)}
//                   {sortColumn === column &&
//                     (sortDirection === "asc" ? (
//                       <ChevronUpIcon size={16} />
//                     ) : (
//                       <ChevronDownIcon size={16} />
//                     ))}
//                 </th>
//               ))}
//               <th className="px-6 py-3 text-sm font-medium text-gray-900 border-b border-gray-200">
//                 More Details
//               </th>
//             </tr>
//           </thead>
//          <tbody>
//             {paginatedData.map((booking, index) => (
//               <tr key={index} className="border-t border-gray-200">
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{booking.service}</td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{booking.date}</td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{booking.status}</td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">{booking.paymentMethod}</td>
//                 <td className="px-6 py-3 text-sm text-gray-900 border-b border-gray-200">
//                   {booking.methods}, {booking.units}, {booking.addons}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//       <span className="text-sm  mt-2  text-gray-600">
//             Showing {indexOfFirstItem + 1} to{" "}
//             {Math.min(indexOfLastItem, bookingDetails.length)} of{" "}
//             {bookingDetails.length} entries
//           </span>

//       {entriesPerPage !== "All" && (
//         <div className="flex items-center  justify-end mt-3">

//          <button
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//             className="px-4 py-2 bg-gray-300 rounded-l hover:bg-gray-400 disabled:opacity-50"
//           >
//             Previous
//           </button>
//           {[...Array(totalPages).keys()].map((page) => (
//             <button
//               key={page + 1}
//               onClick={() => handlePageChange(page + 1)}
//               className={`px-4 py-2 border ${currentPage === page + 1
//                 ? "bg-blue-500 text-white"
//                 : "bg-gray-200 hover:bg-gray-300"
//                 }`}
//             >
//               {page + 1}
//             </button>
//           ))}
//           <button
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//             className="px-4 py-2 bg-gray-300 rounded-r hover:bg-gray-400 disabled:opacity-50"
//           >
//             Next
//           </button>
//         </div>
//       )}

//       {/* Pagination Controls */}
//       {/* <div className="flex justify-between mt-4">
//         <button
//           onClick={handlePrevPage}
//           className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//           disabled={currentPage === 1}
//         >
//           Previous
//         </button>
//         <button
//           onClick={handleNextPage}
//           className="bg-gray-300 py-2 px-4 rounded-md hover:bg-gray-400 focus:outline-none"
//           disabled={currentPage === totalPages}
//         >
//           Next
//         </button>
//       </div> */}

//     </div>
//   );
// };

// export default EditCustomer;

